import React from 'react'
import WhenInView from '../WhenInView'
import ImageSlider from '../ImageSlider'

export default class DeviceSwitch extends React.Component {
  render () {
    if (window.matchMedia('(min-width: 600px)').matches) {
      return (
        <div className='ui container cover'>
          <div className='coverContent mobile hidden'>
            <div className='animation-container-cover'>
              <WhenInView>
                <iframe
                  src='https://interaktiv.tagesanzeiger.ch/2018/schneetage/kugel-tiefe-lagen/snowfall_kugel-tiefe-lagen.html'
                  frameBorder='0'
                  allowtransparency='true'
                  allowFullScreen='allowfullscreen'
                  webkitallowfullscreen='webkitallowfullscreen'
                  mozallowfullscreen='mozallowfullscreen'
                  oallowfullscreen='oallowfullscreen'
                  msallowfullscreen='msallowfullscreen'
                  width='100%'
                  scrolling='no'
                />
              </WhenInView>
            </div>
            <div className='coverTextWrapper'>
              <span className='coverProzentTief'>–48%</span>
              <span className='coverTextTief'>Schneetage in tiefen Lagen</span>
            </div>
          </div>

          <div className='coverContent mobile hidden'>
            <div className='animation-container-cover'>
              <WhenInView>
                <iframe
                  src='https://interaktiv.tagesanzeiger.ch/2018/schneetage/kugel-mittlere-lagen/snowfall_kugel-mittlere-lagen.html'
                  frameBorder='0'
                  allowtransparency='true'
                  allowFullScreen='allowfullscreen'
                  webkitallowfullscreen='webkitallowfullscreen'
                  mozallowfullscreen='mozallowfullscreen'
                  oallowfullscreen='oallowfullscreen'
                  msallowfullscreen='msallowfullscreen'
                  width='100%'
                  scrolling='no'
                />
              </WhenInView>
            </div>
            <div className='coverTextWrapper'>
              <span className='coverProzentMittel'>–33%</span>
              <span className='coverTextMittel'>
                Schneetage in mittleren Lagen
              </span>
            </div>
          </div>

          <div className='coverContent last mobile hidden'>
            <div className='animation-container-cover last'>
              <WhenInView>
                <iframe
                  src='https://interaktiv.tagesanzeiger.ch/2018/schneetage/kugel-hohe-lagen/snowfall_kugel-hohe-lagen.html'
                  frameBorder='0'
                  allowtransparency='true'
                  allowFullScreen='allowfullscreen'
                  webkitallowfullscreen='webkitallowfullscreen'
                  mozallowfullscreen='mozallowfullscreen'
                  oallowfullscreen='oallowfullscreen'
                  msallowfullscreen='msallowfullscreen'
                  width='100%'
                  scrolling='no'
                />
              </WhenInView>
            </div>
            <div className='coverTextWrapper'>
              <span className='coverProzentHoch'>–23%</span>
              <span className='coverTextHoch'>Schneetage in hohen Lagen</span>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className='ui container cover'>
          <div className='coverContent mobile only'>
            <div>
              <WhenInView>
                {/* <iframe
                  src='https://interaktiv.tagesanzeiger.ch/2018/schneetage/kugel-alle-mobile/snowfall_kugel_mobile.html'
                  frameBorder='0'
                  allowtransparency='true'
                  allowFullScreen='allowfullscreen'
                  webkitallowfullscreen='webkitallowfullscreen'
                  mozallowfullscreen='mozallowfullscreen'
                  oallowfullscreen='oallowfullscreen'
                  msallowfullscreen='msallowfullscreen'
                  width='100%'
                  scrolling='no'
                /> */}

                <ImageSlider />
              </WhenInView>
            </div>
          </div>
        </div>
      )
    }
  }
}
